(() => {
	let popupInitApp = (() => {
		let initialize = () => {
			console.log('Here is the popup init function');
			var overlay = document.getElementById('bd-quiz-popup-overlay');
			var closeBtn = document.querySelector('#bd-quiz-popup-overlay .qpo-close');

			if (overlay) {
				var open = () => {
					overlay.classList.add('is-open');
					overlay.setAttribute('aria-hidden', 'false');
				}

				var close = () => {
					// console.log('close event')
					overlay.classList.remove('is-open')
					overlay.setAttribute('aria-hidden', 'true')
				}

				// Open on button click
				document.querySelectorAll('.gbpo-popup-button').forEach(element => {
					element.addEventListener('click', e => {
						console.log("This is the modal button");
						e.preventDefault();
						open();
					})
				})

				// Close on close button click
				if (closeBtn) {
					closeBtn.addEventListener('click', close);
				}

				// Close on overlay background click
				overlay.addEventListener('click', e => {
					// console.log('close event', overlay, e.target);

					// if (e.target === overlay) close();
					if (e.target.classList.contains('mask') && e.target.classList.contains('close')) close();
				})

				// Close on Escape key
				document.addEventListener('keydown', e => {
					if (e.key === 'Escape') close();
				})
			}
		}
		return {
			init: initialize
		}
	})();
	
	document.addEventListener('DOMContentLoaded', () => {
		popupInitApp.init();
	});
})();
